import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiCheck, FiMinus, FiPlus, FiRefreshCw, FiX } from "react-icons/fi"; // Feather icon

import { getAuthUser } from "../utils/auth";
import { saveSelectedPackage } from "../utils/packageSelection";

const packages = [
  {
    type: "custom",
    title: "Set Your Investment",
    price: "25 USD",
    desc: "Invest what you want and see your coins update instantly. Choose your budget and get real-time coin conversion. Your investment, your coins ",
    coins: "2000",
    features: [
      { label: "Fully customizable dollar amount", included: true },
      { label: "Instant coin calculation", included: true },
      { label: "Real-time conversion updates", included: true },
      { label: "Pay only for what you need", included: true },
      { label: "No fixed plans, total flexibility", included: true },
    ],
  },
  {
    title: "Community Member Affiliate Package ",
    discount: "20 % off",
    price: "200$",
    desc: "Start earning instantly with referral access and bonuses.",
    daysLeft: "45 Days Left",
    features: [
      { label: "400,000 Synergy Coins (based on $0.0005 rate)", included: true },
      { label: "50,000 bonus coins on first purchase", included: true },
      { label: "Referral link access", included: true },
      { label: "Earn 500 tokens per referral", included: true },
      { label: "Earn 2,500 tokens per $25 purchase", included: true },
      { label: "Standard member badge", included: true },
      // { label: "2,500 SynergyCoin on your own $25 purchases", included: true },
      { label: "No partner-level rewards", included: false },
      // { label: "Partner-level bonus", included: false },
    ],
  },
  {
    title: "Community Partner Package",
    discount: "20 % off",
    price: "500$",
    desc: "Unlock top-tier rewards and premium partner benefits.",
    daysLeft: "30 Days Left",
    features: [
      { label: "1,000,000 Synergy Coins (based on $0.0005 rate)", included: true },
      { label: "Referral link access", included: true },
      { label: "100,000 bonus coins on first purchase", included: true },
      { label: "Earn 5,000 tokens per $25 purchase", included: true },
      { label: "Priority member badge", included: true },
      // { label: "Priority support", included: true },
      // { label: "Top tier already reached", included: false },
    ],
  },
];

export default function PackagesSection({
  title = "Packages",
  subtitle = "Be part of Synergy Coin’s early growth, secure discounted presale tokens, unlock referral rewards, and grow alongside a global crypto community.",
  breadcrumb = ["Dashboard", "Packages"],
  showHeader = true,
  onBack,
  children,
  fullWidth = false,
  largeCards = false,
}) {
  const cardWidthClasses = largeCards
    ? "w-[90vw] sm:w-[380px] lg:w-[440px]"
    : "w-[90vw] sm:w-[320px] lg:w-[360px]";
  const navigate = useNavigate();
  const authUser = getAuthUser();
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showCongrats, setShowCongrats] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [customAmountInput, setCustomAmountInput] = useState("25");
  const [customAmount, setCustomAmount] = useState(25);
  const [coinAmountInput, setCoinAmountInput] = useState("50000");
  const [showCoinsInBox, setShowCoinsInBox] = useState(false);
  const minUsdAmount = 25;
  const stepUsdAmount = 25;
  const minCoinAmount = 50000;
  const safeCustomAmount = Number.isFinite(customAmount) ? customAmount : minUsdAmount;
  const displayCoinsValue = Math.round(safeCustomAmount * 2000);

  const formatUsdValue = (value) =>
    Number.isInteger(value) ? String(value) : value.toFixed(2);
  const applyUsdAmount = (value) => {
    const normalized = Math.max(minUsdAmount, value);

    setCustomAmount(normalized);
    setCustomAmountInput(formatUsdValue(normalized));
    setCoinAmountInput(String(Math.round(normalized * 2000)));
  };

  const handleCustomAmountChange = (event) => {
    const nextValue = event.target.value;

    if (nextValue === "") {
      setCustomAmountInput("");
      return;
    }

    if (/^\d*\.?\d*$/.test(nextValue)) {
      setCustomAmountInput(nextValue);
      const parsed = Number(nextValue);

      if (Number.isFinite(parsed)) {
        setCustomAmount(parsed);
        setCoinAmountInput(String(Math.round(parsed * 2000)));
      }
    }
  };

  const commitCustomAmount = () => {
    const parsed = Number(customAmountInput);
    const normalized = Number.isFinite(parsed) ? parsed : minUsdAmount;

    applyUsdAmount(normalized);
  };

  const handleCoinAmountChange = (event) => {
    const nextValue = event.target.value;

    if (nextValue === "") {
      setCoinAmountInput("");
      return;
    }

    if (/^\d+$/.test(nextValue)) {
      setCoinAmountInput(nextValue);
      const parsed = Number(nextValue);

      if (Number.isFinite(parsed)) {
        const nextUsd = parsed / 2000;
        setCustomAmount(nextUsd);
        setCustomAmountInput(formatUsdValue(nextUsd));
      }
    }
  };

  const commitCoinAmount = () => {
    const parsed = Number(coinAmountInput);
    const normalizedCoins = Number.isFinite(parsed) ? Math.max(minCoinAmount, parsed) : minCoinAmount;
    const normalizedUsd = normalizedCoins / 2000;

    applyUsdAmount(normalizedUsd);
    setCoinAmountInput(String(normalizedCoins));
  };

  const handleBuy = (item) => {
    saveSelectedPackage(item);

    const navigationTarget = authUser
      ? {
          path: "/checkout",
          options: {
            state: {
              package: {
                ...item,
              },
            },
          },
        }
      : {
          path: "/login",
          options: {
            state: {
              from: {
                pathname: "/checkout",
              },
            },
          },
        };

    setSelectedPackage(item);
    setPendingNavigation(navigationTarget);
    setShowCongrats(true);
  };

  useEffect(() => {
    if (showCongrats && pendingNavigation) {
      const timer = setTimeout(() => {
        navigate(pendingNavigation.path, pendingNavigation.options);
        setShowCongrats(false);
        setSelectedPackage(null);
        setPendingNavigation(null);
      }, 6000);

      return () => clearTimeout(timer);
    }
  }, [navigate, pendingNavigation, showCongrats]);

  return (
    
    <section className="relative w-full overflow-hidden max-sm:pt-4 bg-black-400" >
      <div
        className={`flex w-full flex-col gap-10 ${
          fullWidth
            ? "px-0 sm:px-0 lg:px-0 xl:px-6"
            : "mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 xl:px-0"
        }`}
      >
        {showHeader && (
          <header className="flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <div className="mt-2 text-xs tracking-[0.3em] text-white/60 sm:mt-6">
                {Array.isArray(breadcrumb) &&
                  breadcrumb.map((segment, index) => {
                    const isDashboard = segment.toLowerCase() === "dashboard";

                    return (
                    <span key={segment} className="inline-flex items-center">
                      {isDashboard ? (
                        <button
                          type="button"
                          onClick={() => navigate("/dashboard")}
                          className="transition hover:text-white"
                        >
                          {segment}
                        </button>
                      ) : (
                        <span>{segment}</span>
                      )}
                      {index < breadcrumb.length - 1 && (
                        <span className="mx-2 text-white/20">›</span>
                      )}
                    </span>
                  );
                  })}
              </div>
              {/* {onBack && (
                <button
                  type="button"
                  onClick={onBack}
                  className="rounded-md border border-white/10 bg-white/5 px-4 py-1.5 text-xs font-semibold text-white/70 transition hover:border-white/30 hover:text-white"
                >
                  Back
                </button>
              )} */}
            </div>
            <h2 className="text-3xl font-bold text-white sm:text-4xl">{title}</h2>
            <p className="max-w-2xl text-sm text-white/60 sm:text-base">{subtitle}</p>
          </header>
        )}

        <div className="overflow-x-auto pt-4">
          <div className="flex w-max min-w-full flex-row gap-6 pb-2 lg:gap-8 xl:grid xl:w-full xl:grid-cols-3 xl:gap-8 xl:pb-0">
            {packages.map((item) => {
              const displayItem =
                item.type === "custom"
                  ? {
                      ...item,
                      price: `${formatUsdValue(safeCustomAmount)} USD`,
                    }
                  : item;
              const displayCoins =
                displayItem.type === "custom"
                  ? displayCoinsValue.toLocaleString()
                  : displayItem.coins;

              const amountControl = (
                <div className="mt-8 flex w-full items-center gap-4 rounded-2xl border border-[#7A3EE6]/70 bg-gradient-to-r from-[#2B124F] via-[#2D1A69] to-[#11205C] px-5 py-4">
                  <button
                    type="button"
                    onClick={() => applyUsdAmount(safeCustomAmount - stepUsdAmount)}
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-[#A86BFF]/40 text-[#D7B9FF] transition hover:bg-white/10"
                    aria-label="Decrease amount"
                  >
                    <FiMinus className="h-5 w-5" />
                  </button>
                  {showCoinsInBox ? (
                    <div className="flex flex-1 items-center justify-center">
                      <div className="flex items-center justify-center gap-3 max-w-[220px]">
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          value={coinAmountInput}
                          onChange={handleCoinAmountChange}
                          onBlur={commitCoinAmount}
                          className="w-28 bg-transparent text-center text-3xl font-semibold tracking-tight text-[#E6D6FF] focus:outline-none sm:w-32"
                          aria-label="Custom amount in coins"
                        />
                        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full">
                          <img
                            src="/images/logo.png"
                            alt="Synergy Coin"
                            className="h-8 w-8"
                          />
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="flex flex-1 items-center justify-center gap-1.5 sm:gap-2">
                      <input
                        type="text"
                        inputMode="decimal"
                        pattern="[0-9.]*"
                        value={customAmountInput}
                        onChange={handleCustomAmountChange}
                        onBlur={commitCustomAmount}
                        className="w-20 bg-transparent text-center text-4xl font-semibold tracking-tight text-[#E6D6FF] focus:outline-none sm:w-24"
                        aria-label="Custom amount in USD"
                      />
                      <span className="text-2xl font-semibold text-[#E6D6FF]/80">USD</span>
                    </div>
                  )}
                  <button
                    type="button"
                    onClick={() => applyUsdAmount(safeCustomAmount + stepUsdAmount)}
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-[#A86BFF]/40 text-[#D7B9FF] transition hover:bg-white/10"
                    aria-label="Increase amount"
                  >
                    <FiPlus className="h-5 w-5" />
                  </button>
                </div>
              );

              const coinsRow = (
                <div className="mt-6 flex items-center justify-center gap-3 text-white/70">
                  <button
                    type="button"
                    onClick={() => setShowCoinsInBox((current) => !current)}
                    className="rounded-full p-1 transition hover:bg-white/10"
                    aria-label="Swap amount and coins"
                  >
                    <FiRefreshCw className="h-5 w-5 text-[#C9A7FF]" />
                  </button>
                  <span className="text-lg">=</span>
                  <span className="text-2xl font-semibold text-white/80">{displayCoins}</span>
                  <span className="flex h-8 w-8 items-center justify-center rounded-full">
                    <img
                      src="/images/logo.png"
                      alt="Synergy Coin"
                      className="h-8 w-8"
                    />
                  </span>
                </div>
              );
              const usdRow = (
                <div className="mt-6 flex items-center justify-center gap-3 text-white/70">
                  <button
                    type="button"
                    onClick={() => setShowCoinsInBox((current) => !current)}
                    className="rounded-full p-1 transition hover:bg-white/10"
                    aria-label="Swap amount and coins"
                  >
                    <FiRefreshCw className="h-5 w-5 text-[#C9A7FF]" />
                  </button>
                  <span className="text-lg">=</span>
                  <span className="text-2xl font-semibold text-white/80">
                    {formatUsdValue(safeCustomAmount)}
                  </span>
                  <span className="text-base font-semibold text-white/60">USD</span>
                </div>
              );

              return (
              <article
                key={displayItem.title}
                className={`flex h-[680px] ${cardWidthClasses} flex-col rounded-[36px] border border-white/10 bg-gradient-to-b from-[#1A1B24]/80 via-[#12131A]/90 to-[#0B0C10]/95 justify-between px-6 py-8 shadow-[0_32px_80px_rgba(0,0,0,0.45)] transition-all duration-300 hover:-translate-y-1.5 hover:border-[#A855F7]/40 hover:shadow-[0_40px_110px_rgba(168,85,247,0.45)] xl:w-auto xl:h-auto`}
              >
                <div>
                  {displayItem.type === "custom" ? (
                    <div className="flex flex-col items-center text-center">
                      <h3 className="text-3xl font-semibold text-white">{displayItem.title}</h3>
                      <p className="mt-5 text-sm leading-6 text-white/70">{displayItem.desc}</p>
                      {amountControl}
                      <p className="mt-3 text-xs text-white/50">
                        {showCoinsInBox ? "Minimum 50,000 Coins" : "Minimum 25 USD"}
                      </p>
                      {showCoinsInBox ? usdRow : coinsRow}
                      <ul className="mt-8 w-full space-y-2.5 text-left text-sm">
                        {displayItem.features.map((feature) => (
                          <li
                            key={`${displayItem.title}-${feature.label}`}
                            className="flex items-center gap-3 text-white/80"
                          >
                            <span className="flex h-5 w-5 items-center justify-center rounded-full border border-emerald-400/50 bg-emerald-400/10 text-emerald-300">
                              <FiCheck className="h-3.5 w-3.5" />
                            </span>
                            <span className="text-sm text-white/70">{feature.label}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <>
                      <div className="flex items-center justify-between">
                        <span className="text-xl font-semibold bg-gradient-to-r from-[#ECEFF0] to-[#E5C0FF] bg-clip-text text-transparent">
                          {displayItem.title}
                        </span>
                      </div>

                      <p className="mt-4 text-sm leading-6 text-white/70">{displayItem.desc}</p>

                      <div className="mt-6 flex items-center justify-between text-[11px] font-medium uppercase tracking-[0.35em] text-white/50">
                        <span>Release</span>
                        <span>{displayItem.daysLeft}</span>
                      </div>

                      <div className="mt-6 text-center">
                        <span className="text-[64px] font-black tracking-tight text-transparent bg-gradient-to-b from-[#ECEFF0] to-[#E5C0FF] bg-clip-text">
                          {displayItem.price}
                        </span>
                      </div>

                      <ul className="mt-6 space-y-2.5 text-sm">
                        {displayItem.features.map((feature) => (
                          <li
                            key={`${displayItem.title}-${feature.label}`}
                            className="flex items-center gap-3 text-white/80"
                          >
                            <span
                              className={`flex h-5 w-5 items-center justify-center rounded-full border ${
                                feature.included
                                  ? "border-emerald-400/50 bg-emerald-400/10 text-emerald-300"
                                  : "border-red-400/50 bg-red-500/10 text-red-300"
                              }`}
                            >
                              {feature.included ? (
                                <FiCheck className="h-3.5 w-3.5" />
                              ) : (
                                <FiX className="h-3.5 w-3.5" />
                              )}
                            </span>
                            <span className="text-sm text-white/70">{feature.label}</span>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>

                <button
                  type="button"
                  onClick={() => handleBuy(displayItem)}
                  className="mt-8 rounded-lg bg-[#8C3CDD] py-3 text-sm font-semibold text-white transition hover:bg-[#A367FF] focus:outline-none focus:ring-2 focus:ring-[#A367FF]/60"
                >
                  Buy now
                </button>
              </article>
            );
            })}
          </div>
        </div>

        {children && <div className="mt-8">{children}</div>}
      </div>
      {showCongrats && selectedPackage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-4">
          <div className="w-full max-w-sm rounded-3xl border border-white/15 bg-gradient-to-b from-[#1F1133] to-[#0F0A13] p-8 text-center shadow-[0_25px_80px_rgba(0,0,0,0.65)]">
            <video
              className="mb-5 w-full rounded-2xl border border-white/10"
              src="/images/Videopopup.mp4"
              autoPlay
              loop
              muted
              playsInline
            >
              Your browser does not support the video tag.
            </video>
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-400/20 text-emerald-300">
              <FiCheck className="h-7 w-7" />
            </div>
            <h3 className="text-2xl font-semibold text-white">Congratulations!</h3>
            <p className="mt-2 text-sm text-white/70">
              You selected the <span className="font-semibold text-white">{selectedPackage.title}</span> worth
              <span className="text-white"> {selectedPackage.price}</span>. Enjoy {selectedPackage.features.filter((feature) => feature.included).length} exclusive member perks crafted for
              you.
            </p>
            <div className="mt-4 rounded-2xl border border-white/10 bg-white/5 p-4 text-left text-white/80">
              <p className="text-sm font-medium text-white">What happens next?</p>
              <p className="mt-1 text-xs text-white/70">
                Sit tight while we confirm your package and open the checkout page automatically.
              </p>
            </div>
            <p className="mt-4 text-xs uppercase tracking-[0.3em] text-white/40">Redirecting...</p>
          </div>
        </div>
      )}
      <div className="pb-12 sm:pb-0"></div>
    </section>
    
  );
}
